var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.335 17.4603L6.76833 10.5019C6.42181 10.0687 6.24854 9.85213 6.12533 9.61096C6.01602 9.39699 5.93613 9.16924 5.88782 8.93387C5.83337 8.66858 5.83337 8.39122 5.83337 7.83651V6.93317C5.83337 5.4397 5.83337 4.69296 6.12402 4.12253C6.37969 3.62076 6.78763 3.21282 7.2894 2.95715C7.85983 2.6665 8.60657 2.6665 10.1 2.6665H22.9C24.3935 2.6665 25.1403 2.6665 25.7107 2.95715C26.2124 3.21282 26.6204 3.62076 26.8761 4.12253C27.1667 4.69296 27.1667 5.4397 27.1667 6.93317V7.8365C27.1667 8.39122 27.1667 8.66858 27.1123 8.93387C27.064 9.16924 26.9841 9.39699 26.8747 9.61096C26.7515 9.85213 26.5783 10.0687 26.2317 10.5019L20.665 17.4603M7.16678 3.99983L16.5001 15.9998L25.8333 3.99983M21.2141 17.9525C23.8176 20.5559 23.8176 24.777 21.2141 27.3806C18.6106 29.984 14.3895 29.984 11.786 27.3806C9.1825 24.7771 9.1825 20.556 11.786 17.9525C14.3895 15.349 18.6106 15.349 21.2141 17.9525Z",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward04);
export default __webpack_public_path__ + "static/media/award-04.4189289fbd01f0dad249d28fbcbfd038.svg";
export { ForwardRef as ReactComponent };